/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Model35 } from './model35';
import { Model37 } from './model37';


export interface ProductCreateInput { 
    archived?: boolean;
    createdAt?: string;
    description?: string;
    featured?: boolean;
    fields?: Model35;
    handlingPrice?: number;
    id?: string;
    imageFive?: string;
    imageFour?: string;
    imageOne?: string;
    imageThree?: string;
    imageTwo?: string;
    isRefundable?: boolean;
    locked?: boolean;
    name?: string;
    path?: string;
    price?: number;
    productCategory?: string;
    published?: boolean;
    quantity?: number;
    readOnly?: boolean;
    salePrice?: number;
    shippable?: boolean;
    shippingFree?: boolean;
    skus?: Model37;
    sortOrder?: number;
    taxable?: boolean;
    updatedAt?: string;
    version?: number;
    weight?: number;
}
